import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-2">ALEXI DELFIEUX</h3>
            <p className="text-gray-400 text-sm">aka MOZER</p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">{t.contact.info}</h4>
            <div className="space-y-2 text-sm text-gray-400">
              <p>Phone: +33 6 64 25 28 13</p>
              <p>Phone: +61 480 470 621</p>
              <p>Email: delfieux.alexi@gmail.com</p>
              <p>{t.contact.basedIn}: Paris, France / Melbourne, Australia</p>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4">{t.footer.follow}</h4>
            <a
              href="https://instagram.com/mozer.paint"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span>@mozer.paint</span>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© {currentYear} ALEXI DELFIEUX. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
